module.exports = __webpack_public_path__ + "img/logo.5e342aa1.png";